import { Inject, Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BehaviorSubject, from, Observable, ReplaySubject, Subject, Subscription, throttleTime} from 'rxjs';
import { IMessage, WebsocketModule, WebsocketService } from '../../services/websocket';
import { distinctUntilChanged, filter, first, share } from 'rxjs/operators';
import { isNull } from 'util';
import { DomSanitizer } from '@angular/platform-browser';
import { TelegramService } from '../page-telegram/telegram.service';
import { DeclinationPipe } from '../../pipes/declination.pipe';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { AllService } from '../../services/all.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  Chat,
  Contact,
  IMessengerConnector,
  Message,
  MessageUser,
  Profile, ResultChatDetail, ResultHistory,
  SendMessage
} from '../../types/all.type';
import { NotifierWrapService } from '../../services/notifier-wrap.service';
import { Router } from '@angular/router';
import { log } from '../../functions';
import {InterfaceService} from "../../services/interface.service";
import {DcService} from '../../services/dc.service';

@Injectable({
  providedIn: 'root'
})

export class WhatsappService implements IMessengerConnector {
  public nemuAccounts: IMessengerConnector[] = [];
  public disabledMessageTextarea = false;
  public excludeDomains = [];
  environment = environment;
  public loadHistoryError: boolean | any = false;
  public type = 'whatsapp';
  public name = 'Whatsapp';
  public token: string;
  public unreadCount = 0;
  urlApi: any = 'https://messenger.soft-angel.ru:8001';
  urlApiFileUpload: any = 'https://messenger.soft-angel.ru:8001/api/file/';
  public arChat: Chat[] = [];
  public _openChat: Chat;
  public _openChatId: any;
  public arTyping: MessageUser[] = [];
  public arProfile: Profile = <Profile>{};
  public getProfile$: ReplaySubject<Profile> = new ReplaySubject();
  public setLocalHistory$: ReplaySubject<{
    id: string | number, arHistory: Message[]
  }> = new ReplaySubject();
  public arHistory: Message[] = [];
  public arLocalHistory: any = {};
  public replyMessage: Message | false = false;
  public forwardMessage: Message | false = false;
  public messageLastDate: number;
  public editMessage: Message | false = false;
  public bufferMessage = '';
  public message = '';
  public isLoadedProfile = false;
  public isLoadedProfileError = false;
  public reloadRequestsSubscription: Subscription;
  public httpOptionsMulti: any = {
    headers: new HttpHeaders({
      // 'Content-Type':  'multipart/form-data',
    })
  };
  arVisibleStickers: any = [];
  public isDeleteAllMessage = false;
  private startTimeout: NodeJS.Timeout;
  private arAvatars: any = {};
  public WAStatus$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  disconnectReason: 'replaced' | 'intentional' | 'close' | 'lost';
  public WAStatus = false;
  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    private router: Router,
    public notifierWrapService: NotifierWrapService,
    @Inject('instanceWhatsapp') public wsService: WebsocketService,
    private modal: NzModalService,
    private allService: AllService,
    private declinationPipe: DeclinationPipe,
    public telegramService: TelegramService,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private http: HttpClient
  ) {
    this.getToken();
    this.reloadRequestsSubscription = this.wsService.reloadRequests$.subscribe((val) => {
      if (this.isLoadedProfileError) { this.loadProfile(); }
    });
    // this.arLocalHistory = this.getVarLocal('history', {});
    this.arProfile = this.getVarLocal('profile', {}) || {};
    if (this.arProfile) {
      this.isLoadedProfile = true;
    }
    this.arAvatars = this.getVarLocal('avatars', {}) || {};
    setInterval(() => {
      if (this.isAuth) {
        this.setVarLocal('avatars', this.arAvatars);
      }
    }, 30000);

    // TODO disable this.connect();
    if (this.isAuth){
      this.loadProfile();
    }
    this.setLocalHistory$.pipe(throttleTime(3000)).subscribe((data) => {
      this.setLocalHistory(data.id, data.arHistory);
    });
  }

  get status(): boolean {
    return !this.wsService.disconnect;
  }

  connect() {
    this.wsService.config.url = 'wss://messenger.soft-angel.ru:2389/ws/' + this.allService.token;
    this.wsService.type = 'whatsapp';
    // this.wsService.config.protocol = 'echo-protocol';
    // this.wsService.connect();
    this.wsService.status.subscribe((res) => {
      if (res && this.isAuth) {
        // alert('startConnect1');
        this.startConnect();
      } else {
        this.WAStatus = false;
      }
    });
    this.wsService.on<IMessage>('qr').subscribe((data) => {
      if (this.isAuth) {
        this.logout();
      }
    });
    this.wsService.on<IMessage>('new-message').subscribe((data) => {
      this.allService.wsService.wsMessages$.next({
        event: 'new_message',
        type: this.type,
        data: { new_message: data.new_message, path: this.type }
      });
    });
    this.wsService.on<IMessage>('edit-message').subscribe((data) => {
      this.allService.wsService.wsMessages$.next({
        event: 'edit_message',
        type: this.type,
        data: { edit_message: data.edit_message }
      });
    });
    this.wsService.on<IMessage>('delete-messages').subscribe((data) => {
      this.allService.wsService.wsMessages$.next({
        event: 'delete_messages',
        type: this.type,
        data: { delete_messages: data.delete_messages }
      });
    });

    this.wsService.on<IMessage>('ws-close').subscribe((data) => {
      log('ws-close');
      // alert('startConnect2');
      this.startConnect();
      this.WAStatus = false;
    });
    this.wsService.on<IMessage>('contacts-received').subscribe((data) => {
      // localStorage.setItem('whatsapp_contacts', data.contacts);
    });
    this.wsService.on<IMessage>('auth').subscribe((data) => {
      this.setToken('ok');
      this.WAStatus = true;
      this.WAStatus$.next(true);
      this.allService.login$.next(this);
      // TODO this.goPage();
    });

    this.wsService.on<IMessage>('connect').subscribe((data) => {
      // this.WAStatus$.next(true);
    });
    this.wsService.on<IMessage>('battery').subscribe((data: any) => {
      // this.WAStatus$.next(true);
      this.arProfile.batterylevel = data.batterylevel;
      this.arProfile.battery = data.battery;
      this.arProfile.batteryLive = data.batteryLive;
      this.arProfile.batteryLastTime = Date.now();
      this.setVarLocal('profile', this.arProfile);
      this.dcService.detectChanges$.next('profile');
      this.dcService.detectChanges$.next('battery-indicator');
    });
    this.wsService.on<IMessage>('close').subscribe((data) => {
      log('close');
      // alert('close' + data?.reason);
      // this.logout();
      this.disconnectReason = data?.reason;
      this.WAStatus = false;
      if (this.disconnectReason === 'replaced') {
        this.modal.confirm({
          nzTitle: '',
          nzContent:
            'Приложение WhatsApp открыто на другом компьютере или в другом браузере. Нажмите “Использовать здесь”, чтобы использовать WhatsApp в этом окне.',
          nzOkText: 'Использовать здесь',
          nzCancelText: 'Позже',
          nzOnOk: () => {
            delete this.disconnectReason;
            // alert('startConnect3');
            this.startConnect(0);
          }
        });
      }
    });
    this.wsService.on<IMessage>('error').subscribe((data) => {
      if (data?.error?.status === 401) {
        this.logout();
        this.WAStatus = false;
      }
    });
    this.wsService.on<IMessage>('chats-received').subscribe();
  }
  goPage(): void {
    // this.router.navigate([`/${this.type}/`]);
  }
  startConnect(timeout = 3500) {
    clearTimeout(this.startTimeout);
    this.startTimeout = setTimeout(() => {
      if (this.disconnectReason !== 'replaced') {
        // alert(this.disconnectReason + '!!!!');
        this.wsService.send('start', { text: 'Hello Server!' });
      }
    }, timeout);
  }
  sendEvent(event: string, data: any = {}) {
    if (this.WAStatus) {
      this.wsService.send(event, data);
    } else {
      // alert(event);
      if (this.disconnectReason === 'replaced') {
        delete this.disconnectReason;
        this.startConnect(0);
      }

      const status$ = this.WAStatus$.subscribe((res) => {
        if (res && this.WAStatus) {
          this.wsService.send(event, data);
          status$.unsubscribe();
        }
      });
    }
  }
  getUploadUrl(chatId, type = 'doc'): Observable<{ uploadUrl: string, method: 'post' | 'put' }> {
    return new Observable((observer) => {
      observer.next({uploadUrl: this.urlApiFileUpload, method: 'post'});
      observer.complete();
    })
  }
  getAvatar(id: string | number): Observable<any> {
    const subject = new Subject<any>();
    if (id in (this.arAvatars || {})) {
      setTimeout(() => {
        subject.next(this.arAvatars[id]);
        subject.complete();
      });
    } else {
      this.sendEvent('get_avatar_' + id, { id });
      const s = this.wsService.on<IMessage>('get_avatar_' + id).subscribe((data: any) => {
        this.arAvatars[id] = data?.avatar || '';
        subject.next(this.arAvatars[id]);
        s.unsubscribe();
        subject.complete();
      });
    }
    return subject;
  }
  addedFile(file: File): Observable<{ uploadUrl: string }> {
    return new Observable((observer) => {
      observer.next(undefined);
      observer.complete();
    })
  }
  saveFile(file: File | Blob, title = '') {
    return new Observable((observer) => {
      observer.next(file);
      observer.complete();
    }).pipe(first()); // , tag("saveFile")
  }
  get isAuth(): boolean {
    return !isNull(localStorage.getItem('whatsapp_token'));
  }
  logout(onlyToken = true): void {
    console.warn('WH logout');
    localStorage.removeItem('whatsapp_token');
    if (!onlyToken) {
      this.sendEvent('logout', { text: 'Hello Server!' });
    }

    this.dcService.detectChanges$.next('chat-list');
  }
  getToken() {
    this.token = localStorage.getItem('whatsapp_token');
  }
  setToken(token: string): void {
    localStorage.setItem('whatsapp_token', token);
    this.token = token;
    this.httpOptionsMulti.headers = this.httpOptionsMulti.headers.set('Authorization', 'Token ' + this.token);
    this.dcService.detectChanges$.next('chat-list');
    this.dcService.detectChanges$.next('page-whatsapp');
  }
  getVarLocal(name: string, defaultValue: any = {}) {
    try {
      return JSON.parse(localStorage.getItem('whatsapp_' + name + '_' + this.token)) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }
  setVarLocal(name: string, val: any): void {
    localStorage.setItem('whatsapp_' + name + '_' + this.token, JSON.stringify(val));
  }
  setLocalHistory(id, arHistory: Message[]): void {
    if (!id) { return; }
    this.arLocalHistory[id] = arHistory;
    // this.setVarLocal('history', this.arLocalHistory);
  }
  loadProfile(): Observable<Profile> {
    this.isLoadedProfileError = false;
    this.sendEvent('get_profile');
    const s = this.wsService.on<IMessage>('get_profile').subscribe((data: any) => {
      this.arProfile = data.profile;
      this.isLoadedProfile = true;
      this.setVarLocal('profile', this.arProfile);
      s.unsubscribe();
    });
    return this.getProfile$;
  }
  getProfile(initiator = ''): Observable<Profile> {
    if (this.isLoadedProfile) {
      return new Observable((observer) => {
        observer.next(this.arProfile);
        observer.complete();
      });
    } else {
      return this.loadProfile();
    }
  }
  forwardMessages(chatId: any, fromChatId: any, messages: Message[]) {
    const subject = new Subject<any>();
    this.sendEvent('forward_messages', { chatId, fromChatId, messages });
    const s = this.wsService.on<IMessage>('forward_messages').subscribe((data: any) => {
      subject.next(data);
      s.unsubscribe();
      subject.complete();
    });
    return subject;
  }
  deleteMessages(chatId: any, revoke = true, messageIds: string[]) {
    const subject = new Subject<any>();
    this.sendEvent('delete_messages', { chatId, revoke, messageIds });
    const s = this.wsService.on<IMessage>('delete_messages').subscribe((data: any) => {
      subject.next(data);
      s.unsubscribe();
      subject.complete();
    });
    return subject;
  }
  saveMessage(arMessage: Message) {
    const arData = {
      chat_id: arMessage.chat_id,
      message_id: arMessage.id,
      text: arMessage.text
    };
    const subject = new Subject<any>();
    this.sendEvent('edit_message', arData);
    /// TODO
    const s = this.wsService.on<IMessage>('edit_message').subscribe((data: any) => {
      subject.next(data);
      s.unsubscribe();
      subject.complete();
    });
    return subject;
  }
  sendMessage(arData: SendMessage): Observable<Message[]> {
    const subject = new Subject<any>();
    this.sendEvent('send_message', arData);
    const s = this.wsService.on<IMessage>('send_message').subscribe((data: any) => {
      subject.next([data.message]);
      s.unsubscribe();
      subject.complete();
    });
    return subject;
  }
  sendKeyBoard(arData: any) {
    return this.http.post(`${this.urlApi}/api/vk/messages/`, arData);
  }
  mediaSearch(id, type = 'photo', limit = 15, timeout = 0) {
    const subject = new Subject<any>();
    subject.next([]);
    subject.complete();

    return subject;
  }
  getDetailInfo(chatId: any): Observable<ResultChatDetail> {
    const subject = new Subject<any>();
    const arResult: any = {};
    const chat: any = { id: chatId };
    let user: any;
    subject.next({});
    subject.complete();
    return subject;
  }
  chatSearch(id: any, filter = '') {
    return this.http.get(`${this.urlApi}/api/vk/chats/search/${id}`);
  }
  getChatSearch(id: any, filter = 'empty', query = '', offset = 0, limit = 15) {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }
  getGlobalSearch(query = '', limit = 15) {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }
  sendVoice(file, chat_id): Observable<Message[]> {
    const subject = new Subject<any>();
    subject.next({});
    subject.complete();
    return subject;
  }
  getFile(fileId: string, fileUniqueId: string, ungzip = false) {
    return this.http.get(`${this.urlApi}/api/vk/file/${fileId}/?file_unique_id=${fileUniqueId}&ungzip=${ungzip}`);
  }
  // TODO
  getThumbSrc(attachment) {
    log('getThumbSrc');
  }
  getStickers() {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }
  getGifs() {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }
  deleteFile(uri: string) {
    // TODO Не безопасно!!!
    return this.http.delete(`${this.urlApiFileUpload}?uri=${uri}`);
  }
  setNotify(arData: any): Observable<any> {
    const subject = new Subject<any>();
    this.sendEvent('set_notify', arData);
    const s = this.wsService.on<IMessage>('set_notify').subscribe((data: any) => {
      from(this.arChat)
        .pipe(filter((v: any) => v.id === arData.peer))
        .subscribe((chat: Chat) => {
          chat.mute_until = arData.mute_until;
          this.dcService.detectChanges$.next('chat-list');
        });
      subject.next(data);
      s.unsubscribe();
      subject.complete();
    });
    return subject;
  }
  getNotify(peer: string | number, chat: any = {}): Observable<any> {
    const subject = new Subject<any>();
    setTimeout(() => {
      const findChat = this.arChat?.find((v) => v.id === peer);
      subject.next({
        mute_until: findChat?.mute_until || chat?.mute_until
      });
      subject.complete();
    });
    return subject;
  }
  toggleChatPine(id, pinned: boolean): Observable<any> {
    const subject = new Subject<any>();
    this.sendEvent('chat_pin', { id, pinned });
    const s = this.wsService.on<IMessage>('chat_pin').subscribe((data: any) => {
      s.unsubscribe();
      if (!data.error) {
        subject.next(data);
        subject.complete();
      } else {
        subject.error(data.error);
        subject.complete();
      }
    });
    return subject;
  }
  readHistory(chatId, max_id: string | number): Observable<void> {
    return new Observable((observer) => {
      this.sendEvent('read_history', { chatId, max_id });
      const s = this.wsService.on<IMessage>('read_history').subscribe((data: any) => {
        s.unsubscribe();
        if (!data.error) {
          observer.next();
          observer.complete();
        } else {
          observer.error(data.error);
          observer.complete();
        }
      });
    }); // , tag("readHistory")
  }
  leaveChat(chat_id, del): Observable<any> {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }
  contactsList(q = '', online: any = '', count = 200, timeout = 90): Observable<{results: Chat[] | Contact[]}> {
    this.sendEvent('contacts_list', {
      q,
      online,
      count
    });
    return <any>new Observable((observer) => {
      const s = this.wsService.on<IMessage>('contacts_list').subscribe((data) => {
        data?.contacts.map((v) => (v.online = false));
        setTimeout(() => {
          observer.next({
            results: data?.contacts || []
          });
          observer.complete();
          s.unsubscribe();
        }, 50);
      });
      setTimeout(() => {
        observer.next({ results: [] });
        observer.complete();
        console.error('contactsList timeout');
      }, timeout * 1000);
    }).pipe(first());
  }
  chatList(filterType = '', offset_date = 0, count = 150, timeout = 90): Observable<any> {
    this.sendEvent('chat_list');
    return new Observable((observer) => {
      const s = this.wsService.on<IMessage>('chat_list').subscribe((data) => {
        setTimeout(() => {
          observer.next({ results: data.chats });
          observer.complete();
          s.unsubscribe();
        }, 50);
      });
      setTimeout(() => {
        observer.next({ results: [] });
        observer.complete();
        console.error('Whatsapp chatList timeout');
      }, timeout * 1000);
    }).pipe(first());
  }

  chatNew(title = '', arUsers: any): Observable<any> {
    const subject = new Subject<any>();
    subject.next({});
    subject.complete();
    return subject;
  }

  getHistory(
    chatId: string | number,
    offset_id: string | number = 0,
    currentCount: number,
    limit = 15,
    cursor: any = {}
  ): Observable<ResultHistory> {
    const subject = new Subject<any>();

    this.sendEvent('chat_history_' + chatId, {
      chatId,
      offset_id,
      limit,
      cursor
    });
    const s = this.wsService.on<IMessage>('chat_history_' + chatId).subscribe((data) => {
      subject.next({
        results: data.messages,
        cursor: data.cursor,
        chat: {}
      });
      s.unsubscribe();
      subject.complete();
    });

    return subject;
  }
  /*
   */
  getFileSrc(attachment: any) {
    attachment.file_uri = 'undefined';
    return attachment.file_uri;
  }
  loadAttachment$(attachment): Observable<any> {
    return new Observable((observer) => {
      observer.next({});
      observer.complete();
    });
  }
  getFile$(fileId: string, fileUniqueId = '', text = '') {
    return new Observable((observer) => {
      observer.next('');
      observer.complete();
    }).pipe(first()); // , tag("getFile$")
  }
  getMediaSrc(attachment, prefix = 'photo_') {
    const thumb = '';
    const full = '';
    return { thumb, full };
  }
  valCount(array: any) {
    const names = {};
    array.forEach((item) => {
      names[item] = (names[item] || 0) + 1;
    });
    return names;
  }
  resizeMaxWidth(width: number, height: number) {
    const windowWidth = document.documentElement.clientWidth || window.outerWidth;
    let max_width = windowWidth - (windowWidth > 768 && windowWidth < 1200 ? 600 : 100);
    if (max_width > 300) max_width = 300;
    const k = max_width / width;
    return { width: width * k, height: height * k };
  }
  loadAudio$(attachment) {
    return new Observable((observer) => {
      observer.next(attachment);
      observer.complete();
    }).pipe(first()); // , tag("loadAudio$")
  }
  addChatUser(chat_id, user_id) {
    return new Observable((observer) => {
      this.sendEvent('add_chat_user', { chat_id, user_id });
      const s = this.wsService.on<IMessage>('add_chat_user').subscribe((data) => {
        observer.next(data);
        s.unsubscribe();
        observer.complete();
      });
    });
  }

  errorHandling(error: any, isNotify = true) {
    log('errorHandling');
    log(error);
    if (isNotify) {
      this.notifierWrapService.notify('error', error?.error?.error_text || error?.error?.error_msg || error?.error_msg);
    }
  }
  set openChat(chat: Chat) {
    this._openChat = chat;
  }
  get openChat(): Chat {
    return this._openChat;
  }
  get openChatId() {
    return this._openChatId;
  }
}
